import React from 'react';
import downloadImage from '@assets/images/my-favorites-download-app.png';
import Image from 'next/legacy/image';
import appleStoreLogo from '@assets/images/apple-store-logo.svg';
import googleStoreLogo from '@assets/images/google-store-logo.svg';

export default function DownloadDescription() {
  return (
    <div className="mt-5 mb-5 w-full">
      <div className="font-semibold text-xl leading-7 flex items-center text-gray-900 mt-2 mb-2">
        Download the ResortPass App
      </div>
      <div className="not-italic font-normal text-base leading-7 flex items-end text-gray-500 mt-2 mb-2">
        Your favorites on the go.
      </div>
      <div className="flex focus-within:box-border bg-white border rounded-md p-5">
        <Image src={downloadImage} alt="download" />
        <div className="ml-5 mr-5">
          <div className="not-italic font-semibold text-lg leading-7 flex items-center text-gray-900 mt-5">
            The perfect daycation on the go
          </div>
          <div className="flex flex-row mt-5">
            <div className="w-40 h-12 relative mb-2 cursor-pointer">
              <a href="https://itunes.apple.com/app/id1557539492" target="_blank" rel="noreferrer">
                <Image src={appleStoreLogo} layout="fill" alt="App Store" />
              </a>
            </div>
            <div className="w-40 h-12 relative cursor-pointer ml-5">
              <a
                href="https://play.google.com/store/apps/details?id=com.resortpass.app"
                target="_blank"
                rel="noreferrer"
              >
                <Image src={googleStoreLogo} layout="fill" alt="Google Play" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
